import { render, staticRenderFns } from "./EnroachmentTypeEdit.vue?vue&type=template&id=45af6b34"
import script from "./EnroachmentTypeEdit.vue?vue&type=script&lang=js"
export * from "./EnroachmentTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports